/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { GetStatsByDateQueryResponse, GetStatsByDateQueryParams, GetStatsByDate400 } from '../entities/GetStatsByDate'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getGetStatsByDateUrl() {
  return `/stats/by-date` as const
}

/**
 * @description Get stats by date
 * @summary Get stats by date
 * {@link /stats/by-date}
 */
export async function getStatsByDate(params: GetStatsByDateQueryParams, config: Partial<RequestConfig> & { client?: typeof client } = {}) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<GetStatsByDateQueryResponse, ResponseErrorConfig<GetStatsByDate400>, unknown>({
    method: 'GET',
    url: getGetStatsByDateUrl().toString(),
    params,
    ...requestConfig,
  })
  return res.data
}